module.exports = {
  google: {
    API_KEY: "AIzaSyBYNXQZAvHwTYJPgzP-5qvV4QSFrPcx8qo",
    CLIENT_ID: "657027735097-khi0eop70b410vvi0ho6j9j38ll1frur.apps.googleusercontent.com",
    SECRET: "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",
  },
  facebook: {
    APP_ID: "",
  },
  api: {
    // Auto-detect environment: use localhost for development, production URL otherwise
    API_URL: process.env.NODE_ENV === 'development' 
      ? "https://api.leadwix.com/api"
      : "https://api.leadwix.com/api",
  }
};